import React from 'react';

interface LoadingStateProps {
  isMimicking: boolean;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ isMimicking }) => (
  <div
    className={`min-h-screen bg-gray-50 flex items-center justify-center ${isMimicking ? 'mt-[52px]' : ''}`}
  >
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
      <p className="text-gray-600">Loading website preview...</p>
    </div>
  </div>
);
